(function () {
  "use strict";

  var $formDelete = null;

  // CHANGE: Anamorphik – delete files for client from "my_files/index.php"
  const body = document.querySelector("body");

  const deleteFile = (e) => {
    if (!confirm(json_strings.translations.delete_file_confirmation)) return false;

    const button = e.target.closest("button");
    if (!button) return false;

    const fileID = e.target.closest("button").value;
    if (!fileID) return false;

    // set the file ID to delete
    const $formDeleteFiles = $($formDelete).find("#form_delete_files");
    $formDeleteFiles.val(fileID);

    // then submit the form
    $formDelete.submit();
  };

  if (body.hasAttribute("data-page-id") && body.dataset.pageId === "default_template") {
    $formDelete = $("#form_delete_file"); // delete file form
    const $deleteButtons = $('[name="buttonDeleteFile"]'); // delete buttons

    if ($formDelete && $deleteButtons) {
      $deleteButtons.each(function () {
        $(this).on("click", deleteFile);
      });
    }
  }

  admin.pages.userForm = function () {
    $(document).ready(function () {
      // Display or not the limit accounts selector
      $("#level").on("change", function (e) {
        const el = document.getElementById("limit_upload_to_container");
        if (typeof el !== "undefined" && el != null) {
          if (parseInt($(this).val()) === 7) {
            $("#limit_upload_to_container").slideDown();
          } else {
            $("#limit_upload_to_container").slideUp();
          }
        }
      });

      const form_type = $("#user_form").data("form-type");

      const validator = $("#user_form").validate({
        rules: {
          name: {
            required: true,
          },
          username: {
            required: true,
            minlength: json_strings.character_limits.user_min,
            maxlength: json_strings.character_limits.user_max,
            alphanumericUsername: true,
          },
          email: {
            required: true,
            email: true,
          },
          level: {
            required: true,
          },
          max_file_size: {
            required: true,
            digits: true,
          },
          password: {
            required: {
              param: true,
              depends: function (element) {
                if (form_type === "new_user") {
                  return true;
                }
                if (form_type === "edit_user" || form_type === "edit_user_self") {
                  if ($.trim($("#password").val()).length > 0) {
                    return true;
                  }
                }
                return false;
              },
            },
            minlength: json_strings.character_limits.password_min,
            maxlength: json_strings.character_limits.password_max,
            passwordValidCharacters: true,
          },
        },
        messages: {
          name: {
            required: json_strings.validation.no_name,
          },
          username: {
            required: json_strings.validation.no_user,
            minlength: json_strings.validation.length_user,
            maxlength: json_strings.validation.length_user,
            alphanumericUsername: json_strings.validation.alpha_user,
          },
          email: {
            required: json_strings.validation.no_email,
            email: json_strings.validation.invalid_email,
          },
          level: {
            required: json_strings.validation.no_role,
          },
          max_file_size: {
            digits: json_strings.validation.file_size,
          },
          password: {
            required: json_strings.validation.no_pass,
            minlength: json_strings.validation.length_pass,
            maxlength: json_strings.validation.length_pass,
            passwordValidCharacters: json_strings.validation.alpha_pass,
          },
        },
        errorPlacement: function (error, element) {
          error.appendTo(element.parent("div"));
        },
      });
    });
  };
})();
